const _ = require('lodash'), authenticationHandler = require('./authentication-handler');

module.exports = function ($stateProvider) {
    $stateProvider
        // My Account
        .state('shop.myaccount', {
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    /*
                    * Checkout module is also lazy loaded in the My Account Page. Woolworths Rewards section requires the Chekout Service from the module
                    * to handle the vaildation of the card number.
                    */
                    return $ocLazyLoad.load(['myaccount', 'checkout']);
                }],
                authMethod: ['ShopperService', shopperService =>
                    (shopperService.getAuthenticationMethod().then(response => response.AuthenticationMethod)),
                ],
            },
            url: '/myaccount',
            onEnter: [
                '$state', '$q', 'LoginService', 'authMethod',
                _.partialRight(authenticationHandler, 'Please reauthenticate before accessing My Account'),
            ],
            views: {
                'left-panel@shop': {
                    template: '<wow-my-account-nav-links></wow-my-account-nav-links>',
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>',
                },
            },
            data: {
                authenticate: true,
                pageMetadata: {
                    title: 'Account Details',
                    metaDescription: 'Account Details',
                },
            },
        })
        .state('shop.myaccount.accessibility', {
            url: '/accessibility',
            views: {
                'center-panel@shop': {
                    template: '<wow-shopper-accessibility></wow-shopper-accessibility>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.preferences', {
            url: '/preferences',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-shopper-preferences></wow-my-account-shopper-preferences>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.deliveryaddresses', {
            url: '/deliveryaddresses',
            views: {
                'center-panel@shop': {
                    template: '<div class="myaccount"><wow-my-account-delivery-addresses></wow-my-account-delivery-addresses></div>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.changepassword', {
            url: '/password',
            views: {
                'center-panel@shop': {
                    template: '<wow-change-password></wow-change-password>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.woolworthsrewards', {
            url: '/woolworthsrewards',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-everyday-rewards></wow-my-account-everyday-rewards>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.trackmyorder', {
            url: '/trackmyorder',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-track-my-order></wow-my-account-track-my-order>',
                },
                'left-panel@shop': {
                    template: '<wow-my-account-nav-links></wow-my-account-nav-links>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.trackmyorder.orderId', {
            url: '/:orderId',
        })

        // My Account- Account details
        .state('shop.myaccount.details', {
            url: '/details',
            views: {
                'center-panel@shop': {
                    template: '<div class="myaccount"><wow-my-account-details></wow-my-account-details></div>',
                },
            },
            data: {
                authenticate: true,
            },
        })

        // My Account - Delivery Savers
        .state('shop.myaccount.deliverysavers', {
            url: '/deliverypasses',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-delivery-savers></wow-my-account-delivery-savers>',
                },
            },
            data: {
                authenticate: true,
            },
        })

        // My Account - My invoices lists
        .state('shop.myaccount.myinvoices', {
            url: '/myinvoices?{pageNumber:int}&{searchInvoice}&{startDate}&{endDate}',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-invoices></wow-my-invoices>',
                },
            },
            data: {
                authenticate: true,
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/myaccount.js